// Core Modules
import { Component, inject } from '@angular/core';

// Services
import { ConfigService } from '@core/services/config/config.service';

// Models
import { FooterContentModel } from '@shared/models/footer-content.model';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  // Injectors
  private readonly configService = inject(ConfigService);

  // Public Members
  public readonly copyrightTextPrimary: string;
  public readonly copyrightTextSecondary: string;
  public readonly footerContents: FooterContentModel;

  constructor() {
    // Load the footer static contents from app-contents.json file
    const currentYear = new Date().getFullYear();
    this.footerContents = this.configService.getContents('footer');
    // set copyright text
    const { primary, secondary } = this.footerContents.copyrightText;
    this.copyrightTextPrimary = `Copyright ${currentYear} ${primary}`;
    this.copyrightTextSecondary = secondary;
  }
}
